"use strict";

exports.__esModule = true;
var MOBILE_MIN_WIDTH = exports.MOBILE_MIN_WIDTH = 320;
var TABLET_MIN_WIDTH = exports.TABLET_MIN_WIDTH = 768;
var DESKTOP_MIN_WIDTH = exports.DESKTOP_MIN_WIDTH = 1025;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/constants/media.js
// module id = 245
// module chunks = 79611799117203 213534597649335